import { listAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const variants = {
    autoSuggest: definePartsStyle({
        container: {
            width: "100%",
            boxSizing: "border-box",
            position: "absolute",
            zIndex: 1,
            marginTop: "0.25rem",
            p: "0",
            border: "1px solid",
            borderColor: "semantic.border.secondary",
            shadow: "large",
            backgroundColor: "semantic.surface.1",
        },
        item: {
            py: "0.5rem",
            px: "0.75rem",
            borderWidth: 0,
            outlineWidth: 0,
            h: "12",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "semantic.text.primary",
            fontWeight: "core.demiBold",
            fontSize: "4",
            lineHeight: "core.9",
            _hover: { bg: "core.boldyBlue.2", cursor: "pointer" },
            "&.ds-autosuggest-focused-option": {
                bg: "core.boldyBlue.2"
            }
        },
    }),
};
const ListTheme = defineMultiStyleConfig({
    variants,
});
export default ListTheme;
//# sourceMappingURL=List.default.js.map